import React from 'react';

interface Props {
  contributionRatio: number;
}

const WagerIcon: React.FC<Props> = ({ contributionRatio }) => {
  const circleRadius = 15.91549430918954;
  const strokeDasharray =
    Math.round((1 - contributionRatio) * 100) + ' ' + Math.round(contributionRatio * 100);
  return (
    <svg width="100%" height="100%" viewBox="2 2 38 38">
      <defs>
        <linearGradient id="re20s7lu5a" x1="17.871%" x2="72.685%" y1="92.62%" y2="15.363%">
          <stop offset="0%" stopColor="#18b178" />
          <stop offset="100%" stopColor="#33e149" />
        </linearGradient>
        <linearGradient id="re20s7lu6a" x1="17.871%" x2="72.685%" y1="92.62%" y2="15.363%">
          <stop offset="0%" stopColor="#3e49c4" />
          <stop offset="100%" stopColor="#892bd4" />
        </linearGradient>
      </defs>
      <circle cx="21" cy="21" r={circleRadius} fill="transparent" />
      <circle
        cx="21"
        cy="21"
        r={circleRadius}
        fill="transparent"
        stroke="url(#re20s7lu5a)"
        strokeWidth="4"
      />
      <circle
        cx="21"
        cy="21"
        r={circleRadius}
        fill="transparent"
        stroke="url(#re20s7lu6a)"
        strokeWidth="4"
        strokeDasharray={strokeDasharray}
        strokeDashoffset="25"
      />
    </svg>
  );
};

export default WagerIcon;
